module.exports = __webpack_public_path__ + "img/logo2.8898edc5.png";